<template>
  <div id="app">
    <div style="display: none">聂章帅</div>
    <!-- <Header></Header> -->
    <Content></Content>
    <!-- <Content1></Content1>   -->
    <!-- <router-view></router-view> -->
    <Footer></Footer>

    <video class="video" src="./assets/video/bj.mp4" autoplay="autoplay" loop="loop" muted></video>
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import Content from "@/components/Content.vue";
  import Content1 from "@/components/Content1.vue";
  import Footer from "@/components/Footer.vue";
  export default {
    data() {
      return {};
    },
    created() { },
    methods: {},
    components: {
      Header,
      Footer,
      Content,
      Content1,
    },
  };
</script>


<style>
  body,
  div,
  li,
  ul,
  a,
  p,
  span,
  img {
    margin: 0;
    padding: 0;
  }

  * {
    margin: 0;
    padding: 0;
  }

  body {
    /* overflow-x: hidden; */
  }

  a {
    text-decoration: none;
  }

  #app {
    width: 100%;
    height: 100vh;
    min-width: 1300px;
    min-height: 870px;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    position: relative;
  }

  .r {
    float: right;
  }

  ul,
  li {
    list-style: inside none;
  }

  .video {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: calc(100vw - 8px);
    min-width: 1300px;
    height: auto;
  }

  /* .content {
  position: absolute;
  left: 360px;
  top: 700px;
} */
  .footer {
    /* position: fixed; */
    position: absolute;
    /* margin-top: 50px; */
    bottom: 0px;
  }

  /* //滚动条的宽度 */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  /* //滚动条的滑块 */
  ::-webkit-scrollbar-thumb {
    background-color: rgba(51, 51, 51, 0.26);
    border-radius: 8px;
  }
</style>